import { createStore } from 'vuex'
import { loadTestResults, saveTestResults, clearTestResults } from '@/utils/storage'

export default createStore({
  state: {
    testResults: loadTestResults(), // 从 localStorage 恢复测试结果
    talents: {
      A: "语言天赋",
      B: "逻辑-算数天赋",
      C: "空间天赋",
      D: "内省天赋",
      E: "人际天赋",
      F: "身体-动觉天赋",
      G: "音乐天赋",
      H: "自然天赋",
      I: "创造天赋",
      J: "美学天赋"
    }
  },
  mutations: {
    setTestResults(state, results) {
      console.log('保存测试结果到 state:', results)
      state.testResults = results
    },
    clearTestResults(state) {
      state.testResults = null
    }
  },
  actions: {
    saveTestResults({ commit }, results) {
      commit('setTestResults', results)

      try {
        // 同时保存到 localStorage
        saveTestResults(results)
      } catch (error) {
        console.error('保存测试结果失败:', error)
      }
    },
    resetTest({ commit }) {
      commit('clearTestResults')
      // 同时清除 localStorage 中的测试结果
      clearTestResults()
    }
  },
  getters: {
    testResults: state => state.testResults,
    talents: state => state.talents
  }
})

